import React from 'react';
import { useNavigate } from 'react-router-dom';
import EndlessRail from '../EndlessRail';
import RailHeader from './RailHeader';
import { cn } from '../../lib/utils';

const TrendingTop10Rail = ({ items = [], loading }) => {
  const navigate = useNavigate();

  if (loading) return null;
  if (items.length === 0) return null;

  return (
    <section>
      <RailHeader title="Top 10 Today" />
      <EndlessRail
        items={items.slice(0, 10)}
        loop={false}
        slideWidth="top10"
        ariaLabel="Top 10 today"
        renderItem={(item, i) => {
          const rank = i + 1;
          const href = item.slug
            ? `/watch/${item.slug}`
            : item.id
              ? `/video/${item.id}`
              : '/browse';
          return (
            <button
              key={item.id ?? i}
              type="button"
              onClick={() => navigate(href)}
              className={cn(
                'group w-full cursor-pointer text-left',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background'
              )}
            >
              <div
                className={cn(
                  'relative aspect-[2/3] overflow-hidden rounded-lg bg-[hsl(var(--kinora-card-hi))]',
                  'ring-1 ring-transparent transition-[box-shadow,ring-color] duration-300',
                  'group-hover:ring-primary/25 group-hover:shadow-md'
                )}
              >
                {item.thumbnail ? (
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] motion-reduce:group-hover:scale-100"
                  />
                ) : (
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-card to-card" />
                )}
                <span
                  className={cn(
                    'absolute bottom-1 left-1 z-10 text-5xl font-bold tabular-nums leading-none drop-shadow-[0_2px_12px_rgba(0,0,0,0.9)] md:text-6xl',
                    rank === 1 ? 'text-primary' : 'text-white'
                  )}
                  style={{ WebkitTextStroke: '1px rgba(0,0,0,0.3)' }}
                >
                  {rank}
                </span>
              </div>
              <p className="mt-2 line-clamp-2 text-sm font-medium leading-snug text-foreground group-hover:text-primary">
                {item.title}
              </p>
            </button>
          );
        }}
      />
    </section>
  );
};

export default TrendingTop10Rail;
